"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBatchCommitChangesResultRetcode = exports.BatchCommitFailReason = void 0;
/**
 *  批量提交错误原因
 *
 * @enum {number}
 */
var BatchCommitFailReason;
(function (BatchCommitFailReason) {
    BatchCommitFailReason["UNKNOW"] = "Unknow";
    BatchCommitFailReason["SUCCESS"] = "Success";
    /**
     * 网络原因，数据可能未到达服务器
     */
    BatchCommitFailReason["NETWORK_EXCEPTION"] = "NetworkException";
    /**
     * 服务器处理数据异常
     */
    BatchCommitFailReason["SERVER_VERITY_EXCEPTION"] = "ServerVerityException";
})(BatchCommitFailReason || (BatchCommitFailReason = {}));
exports.BatchCommitFailReason = BatchCommitFailReason;
/**
 * 批量提交本地错误码
 *
 * @enum {number}
 */
var IBatchCommitChangesResultRetcode;
(function (IBatchCommitChangesResultRetcode) {
    IBatchCommitChangesResultRetcode[IBatchCommitChangesResultRetcode["SUCCESS"] = 0] = "SUCCESS";
    /**
     * 服务器处理超时，遇到的案例以 io 超时为主
     */
    IBatchCommitChangesResultRetcode[IBatchCommitChangesResultRetcode["ServerTimeout"] = 101] = "ServerTimeout";
    /**
     * 服务器检查无效的参数，比如 xsrf、padId 等
     */
    IBatchCommitChangesResultRetcode[IBatchCommitChangesResultRetcode["ServerInvalidParam"] = 10001] = "ServerInvalidParam";
    /**
     * 未知错误
     */
    IBatchCommitChangesResultRetcode[IBatchCommitChangesResultRetcode["UNKNOWN_ERROR"] = 52000] = "UNKNOWN_ERROR";
    /**
     * 用户权限校验失败
     */
    IBatchCommitChangesResultRetcode[IBatchCommitChangesResultRetcode["USER_PRIVILEGE_FAILED"] = 200111] = "USER_PRIVILEGE_FAILED";
    /**
     * 参数错误
     */
    IBatchCommitChangesResultRetcode[IBatchCommitChangesResultRetcode["PARAMETER_WRONG"] = 52001] = "PARAMETER_WRONG";
    /**
     * Websocket不支持批量提交
     */
    IBatchCommitChangesResultRetcode[IBatchCommitChangesResultRetcode["WEBSOCKET_UNSUPPORT_BATCH_COMMIT"] = 52002] = "WEBSOCKET_UNSUPPORT_BATCH_COMMIT";
    /**
     * 超过大数据通道提交内容长度
     */
    IBatchCommitChangesResultRetcode[IBatchCommitChangesResultRetcode["CONTENT_LENGTH_EXCEED_LIMIT"] = 52003] = "CONTENT_LENGTH_EXCEED_LIMIT";
})(IBatchCommitChangesResultRetcode || (IBatchCommitChangesResultRetcode = {}));
exports.IBatchCommitChangesResultRetcode = IBatchCommitChangesResultRetcode;
